import React from 'react';
import './App.css';
import Nav from './components/Nav';
import Button from './components/Button';
import Teaching from './components/Teaching';
import Contact from './components/Contact';
import Overlay from './components/Overlay';



function App() {
  return (
    <div className="App">
      <Nav />
      <header className="App-header" id="home">
        <div className="welcome">
        <h1>Welcome to Muse Tuition</h1>
        <p>Music teaching on the go</p>
        </div>
        <div className="notes-right shapeshifter play"></div>
        <div className="notes-left shapeshifter2 play"></div>
        <img src={require("./images/notesright.svg")} alt="music notes right" className="notes-right static"/>
        <img src={require("./images/notesleft.svg")} alt="music notes left" className="notes-left static"/>
        <div className="buttonSection">
          <Overlay btnname="Services"/>
          <Button name="Teacher Profile" className="teaching-but" id="#teaching"/>
          <Button name="Contact Me" className="contact-but" id="#contact"/>
        </div>
        <Teaching id="teaching"/>
        <Contact id="contact"/>
        
      </header>
    </div>
  );
}

export default App;
